(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/views/news-error.js') >= 0) return;  svs.modules.push('/components/sport/news/views/news-error.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.news=_svs.sport.news||{};
_svs.sport.news.templates=_svs.sport.news.templates||{};
svs.sport.news.templates.news_error = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.errorMessage : depth0)) != null ? stack1.message : stack1), depth0))
    + "\n";
},"useData":true});
Handlebars.partials['components-sport-news-news_error'] = svs.sport.news.templates.news_error;
})(svs, Handlebars);

 })(window);